<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <div>
      <div class="text-right pb-5">
        <v-btn style="margin-right: 10px;" v-on:click="downloadFolder()">
          <v-icon left>mdi-download</v-icon>
          ダウンロード
        </v-btn>
        <v-btn v-on:click="uploadFolder()">
          <v-icon left>mdi-cloud-upload</v-icon>
          アップロード
        </v-btn>
      </div>
      <v-card height="100%">
        <v-card-title class="title pa-0" ref="title">
          <h3 style="margin-right: 10px; margin-left: 10px;">画面一覧</h3>
          <div class="text-h5">({{totalVideos}}件)</div>
          <v-row justify="center">
            <v-col cols="auto" align-self="center">
              <v-btn
                  fab
                  color="grey lighten-1"
                  small
                  @click="previousImage()"
              >
                <v-icon small> mdi-less-than</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                  <h5 class="text-truncate" style="max-width: 350px" v-bind="attrs" v-on="on">{{ getVideoName(currentVideoIndex) }}</h5>
                </template>
                <h5>{{ getVideoName(currentVideoIndex) }}</h5>
              </v-tooltip>
            </v-col>
            <v-col cols="auto" align-self="center">
              <v-btn
                  fab
                  color="grey lighten-1"
                  small
                  @click="nextImage()"
              >
                <v-icon small> mdi-greater-than</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div style="margin-right: 10px;">
            <v-icon size="30" color="primary" v-on:click="downloadVideo(currentVideoIndex)" download>mdi-download</v-icon>
            <v-icon size="30" color="red" v-on:click="deleteVideo(currentVideoIndex)" v-if="folder.created_user === sharedState.email || sharedState.role === 'admin'">mdi-delete</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" style="position:relative" ref="left_list_col">
              <v-row ref="left_list" style="width: 350px; overflow: auto;">
                <v-col v-for="n in videos.length" :key="n" class="d-flex child-flex" cols="6" style="position:relative" :class="videos[currentVideoIndex] === videos[n-1] && videos.length !== 0? 'chosen-video' : ''">
                  <div>
                    <video width="100%" v-on:click="chooseVideo(n-1)">
                      <source :src="videos[n-1]" type="video/mp4">
                    </video>
                    <v-tooltip bottom>
                      <template v-slot:activator="{on, attrs}">
                        <p class="video-title text-truncate" v-bind="attrs" v-on="on">{{getVideoName(n-1)}}</p>
                      </template>
                      <p class="video-title text-truncate">{{getVideoName(n-1)}}</p>
                    </v-tooltip>
                  </div>
                  <div class="float-top" v-if="n <= videos.length">
                    <v-icon color="rgba(25, 118, 210, 0.8)" v-on:click="downloadVideo(n-1)" download>mdi-download</v-icon>
                    <v-icon color="rgba(244, 67, 54, 0.8)" v-on:click="deleteVideo(n-1)" v-if="folder.created_user === sharedState.email || sharedState.role === 'admin'">mdi-delete</v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="center" ref="pagination_row" class="pagination">
                <div class="text-center" ref="pagination" style="margin-top: 10px;">
                  <v-pagination
                      v-model="pagination.page"
                      :length="Math.ceil(totalVideos/pagination.per_page)"
                      circle
                      @input="changePage"
                  ></v-pagination>
                </div>
              </v-row>
            </v-col>
            <v-col style="text-align: center;">
              <video controls ref="video" id="main-video">
                <source :src="videos[currentVideoIndex]" type="video/mp4">
              </video>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <video-upload-dialog v-model="uploadFolderDialog" :folderId="folderId" @uploadedVideo="onUploaded()"></video-upload-dialog>
    </div>
  </v-container>
</template>

<script>
import {store} from "@/store";
import download from "downloadjs";
import VideoUploadDialog from "@/components/dialog/VideoUploadDialog";

export default {
  name: "VideoDetail",
  components: {
    "video-upload-dialog": VideoUploadDialog,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: "",
          disabled: false,
          exact: true,
        },
        {
          text: "",
        },
      ],
      videos: [],
      currentVideoIndex: 0,
      pagination: {
        page: 1,
        per_page: 10,
      },
      totalVideos: 0,
      uploadFolderDialog: false,
      folder: {
        block_id: null,
        name: null,
        property: {
          weather: null,
          solar_radiation: null,
        },
        created_user: null
      },
      folderId: this.$route.params.folderId,
      sharedState: store.state
    }
  },
  methods: {
    async init() {
      await this.axios
          .post('/api/folder/videos/' + this.folderId, this.pagination)
          .then((response) => {
            this.videos = response.data;
            this.totalVideos = parseInt(response.headers["x-total"]);
          });
    },
    async previousImage() {
      if (this.currentVideoIndex > 0) {
        this.currentVideoIndex = this.currentVideoIndex - 1;
        this.chooseVideo(this.currentVideoIndex);
      } else {
        if (this.pagination.page !== 1) {
          this.pagination.page = this.pagination.page - 1;
          await this.init();
          this.chooseVideo(this.videos.length - 1);
        }
      }
    },
    async nextImage() {
      if (this.currentVideoIndex < this.videos.length - 1) {
        this.currentVideoIndex = this.currentVideoIndex + 1;
        this.chooseVideo(this.currentVideoIndex);
      } else {
        if (this.pagination.page !== Math.ceil(this.totalVideos / this.pagination.per_page)) {
          this.pagination.page = this.pagination.page + 1;
          await this.init();
          this.chooseVideo(0);
        }
      }
    },
    chooseVideo(index){
      if (index < this.videos.length){
        this.currentVideoIndex = index;
        this.$refs.video.load();
      }
    },
    downloadVideo(index){
      if (this.videos && index < this.videos.length){
        const filename = this.getVideoName(index);
        const x = new XMLHttpRequest();
        x.open("GET", this.videos[index], true);
        x.setRequestHeader('Access-Control-Allow-Origin', '*');
        x.responseType = 'blob';
        x.onload=function(){download(x.response, filename); }
        x.send();
      }
    },
    deleteVideo(index){
      const confirm = {
        title: '動画削除確認',
        content: '選択した動画を削除します。よろしいですか。',
        onAgree: () => {
          this.axios
              .delete('/api/folder/videos/delete/' + this.folderId, {data: {'name': this.getVideoName(index)}})
              .then(async () => {
                await this.init();
                this.chooseVideo(this.currentVideoIndex);
              })
              .catch(() => {
                store.showErrorDialog('エラーが発生しました。担当者に連絡してください。');
              });
        }
      }
      store.showConfirmDialog(confirm);
    },
    async changePage() {
      await this.init();
      this.chooseVideo(0);
    },
    getVideoName(index){
      if (this.videos.length !== 0 && index < this.videos.length){
        return this.videos[index].split('/')[6];
      }
      return '';
    },
    downloadFolder(){
      window.location.href = '/api/folder/videos/download/' + this.folderId + '?token=' + store.state.token;
    },
    uploadFolder(){
      this.uploadFolderDialog = true;
    },
    async onUploaded() {
      await this.init();
      this.chooseVideo(this.currentVideoIndex);
    },
    getFolder() {
      this.axios
          .get("/api/folder/" + this.$route.params.folderId)
          .then((response) => {
            this.folder = response.data.folder;
            this.breadcrumbs[2].text = this.folder.property.shooting_date;
            this.getPlant(this.folder.plant_id);
          });
    },
    getPlant(plantId) {
      this.axios
          .get('/api/main-plant/' + plantId)
          .then((response)=>{
            this.plant = response.data;
            this.breadcrumbs[1].text = this.plant.plant_name;
            this.breadcrumbs[1].to = "/plant/" + plantId + "/folder";
          });
    },
  },
  async mounted() {
    this.$refs.pagination_row.style.height = this.$refs.pagination.clientHeight + 10 + 'px';
    this.$refs.left_list.style.maxHeight = this.$refs.left_list_col.clientHeight - this.$refs.pagination_row.clientHeight + 30 + 'px';
    await this.init();
    this.chooseVideo(0);
  },
  created() {
    this.getFolder();
  }
}
</script>

<style scoped>
.float-top{
  position: absolute;
  top: 17px;
  right: 17px;
  background-color: rgba(255, 255, 255, 0.7);
}
.chosen-video{
  border: 2px solid #1976D2;
}
#main-video {
  width: 100%!important;
  height: 100%!important;
}
.video-title{
  text-align: center;
  margin-bottom: 0;
}
.pagination{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
</style>
